import React from 'react';
import './Services1.css';
// import gallery1 from '../../assets/gallery1.jpg';
import a1 from '../../assets/a1.jpg';
import a2 from '../../assets/a2.jpg';
import a3 from '../../assets/a3.jpg';
import a4 from '../../assets/a4.png';
import a5 from '../../assets/a5.jpg';
import a6 from '../../assets/a6.jpg';


const services = [
    {
        title: "Holistic Wealth & Financial Planning",
        image: a1,
        description: "We go beyond traditional investment advice to craft comprehensive, goal-aligned financial roadmaps tailored to your life aspirations. Our approach integrates every aspect of your financial life - including investments, insurance, estate planning, taxation, cash flows, and real estate into a cohesive strategy that grows with you. Whether you're planning for retirement, funding your child’s education, buying property, or preserving family wealth.",
    },
    {
        title: "Curated Access to Top Fund Managers and Investment Products",
        image: a2,
        description: "We help you identify and invest with the most trusted fund managers across asset classes, based on your unique goals, risk profile, and time horizon across leading Mutual Funds across Equity, Debt, ELSS, and Hybrid category, PMS with differentiated investment strategies and High-quality Alternative Investment Funds including Private Credit, Real Estate Credit, Long Short, Venture Capital Funds.",
    },
    {
        title: "Family Office Services",
        image: a3,
        description: "We help business families structure, scale, and sustain intergenerational wealth. Through content, case studies, and strategic inputs, We support the creation and evolution of family offices in India. We not only offer the advisory in creation of family office structure, we also bring access to the top funds which other family offices are invested in, and also the network of big family offices to co-invest and learn from their investing journey.",
    },
    
    {
        title: "NRI Wealth Management",
        image: a4,
        description: "We specialize in guiding Non-Resident Indians (NRIs) through the complexities of cross-border wealth. From tax-efficient investment strategies and regulatory compliance to end-to-end financial planning, we offer seamless solutions tailored to your global lifestyle. Our trusted advisory bridges geographies with clarity, precision, and personalized care — ensuring your India-linked wealth is managed with confidence and ease.",
    },
    
    
    {
        title: "SME IPO Advisory & Fundraising",
        image: a5,
        description: "We work with SMEs and startups to navigate private capital markets and public listing requirements. From loan syndication to merchant banker connections, we support businesses seeking capital growth. We help them with their preparation stage before they go to merchant bankers, in terms of sector research, books preparation and pitch decks and connect them with our network of merchant bankers and assist them in the whole IPO Journey.",
    },
    {
        title: "Macro Research & Treasury Outlook",
        image: a6,
        description: "Ensure financial stability for your family with our life insurance options.Our original blogs and research cover macroeconomic trends, rate cycles, and investment themes. This content supports decision-makers in making informed choices in uncertain markets. It brings together our own proprietary research of our management team and also from our esteemed contributors from esteemed Banks and Organizations to shape market view and perspective.",
    },
    
];

const Services1 = () => {
    return (
        <div className="services-section">
            <h1 className="services-title">Know Our Services</h1>
            <div className="services-grid">
                {services.map((service, index) => (
                    <div
                        className="service-card"
                        key={index}
                        style={{ backgroundImage: `url(${service.image})` }}
                    >
                        <div className="overlay">
                            <h2>{service.title}</h2>
                            <p>{service.description}</p>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default Services1;
